export const roundNumber = num => {
  // var m = Number((Math.abs(num) * 100).toPrecision(15));
  // return Math.round(m) / 100 * Math.sign(num);
  // return +(Math.round(num + "e+2")  + "e-2");
  return Math.round((num + Number.EPSILON) * 100) / 100;
};